import React, { useCallback } from 'react';
import { MdDirectionsWalk } from 'react-icons/md';
import { useForm } from '~/hooks';
import { useSectionLoader } from '../../hooks';
import sectionTypes from '../sectionTypes';
import EasementGrid from './EasementGrid';
import { SectionHeader } from '../../../PolicySearchRequest/common';

/**
 * @typedef EasementsValues
 * @property {number} sectionId
 * @typedef FormState
 * @property {EasementsValues} values The current form values
 */

/** @type {EasementsValues} */
const defaultState = {
    sectionId: 0,
    orderNumber: null
};

const Easements = ({ titleOpinionId, readOnly }) => {
    const { onLoad: loadSection } = useSectionLoader(sectionTypes.EASEMENTS, titleOpinionId);


    const onLoad = useCallback((values) => {
        return loadSection(values);
    }, [titleOpinionId]);

    const {
        /** @type {FormState} */
        state,
        fieldActions
    } = useForm({
        /** @type {RestrictiveCovenantsValuesValues} */
        initialState: { ...defaultState },
        onLoad,
        debug: true
    });

    return (
        <div className="ml-5 mr-5">
            <div className="mb-5">
                <div>
                    <div className="z-10 flex items-center h-full text-xl font-semibold text-blue-60">
                        <div className="h-11 w-11 rounded-md flex items-center justify-center bg-blue-30"><MdDirectionsWalk size="45%"/></div>
                        <div className="ml-2"> Easements &amp; Rights of Way </div>
                    </div> 
                    
                </div>
            </div>
            <div className="text-sm mb-4">Please note any information changes will overwrite any previously entered. Changes are saved automatically.</div>            
            <div className="col-span-8 grid grid-cols-12 grid-flow-row gap-x-8 gap-y-4 text-sm bold mb-4 mt-4">
                {/* Liens, Mortgages & Deeds of Trust */}
                <SectionHeader colSpan={12}> Other Easements or Right of Way</SectionHeader>
                <EasementGrid colSpan={12} fieldActions={fieldActions} titleOpinionId={titleOpinionId} sectionId={state.values.sectionId} sectionDetails={state.values.sectionDetails} editMode={!readOnly}  initialDefaultData={state.values.initialDefaultData}/>
              
            </div>
        </div>
    );
};

export default Easements;